<template>
  <div>
    <!-- 远程操作组件 -->
    <!-- 根据选择列表显示 -->
    <!-- 传入title当前操作标题 -->
    <el-dialog :title="title" :visible.sync="Device" width="40%" center @close="dialogClose"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <p class="Device-list-name">{{ $t('lang.Dialog.affected') }}</p>
      <ul>
        <li v-for="(item, index) in Devicelistname" :key="item.deviceId">
          <span>{{ item.deviceSn }},</span>
        </li>
      </ul>
      <div v-if="types == 12 && m2mList.length > 0" class="status">
        <p>正在执行中，执行情况如下：</p>
        <div>
          <el-tag v-for="item in m2mList" :type="item.status"> {{ item.deviceSn }}</el-tag>
        </div>
        <p>
          灰色代表等待执行，绿色代表执行成功，红色代表执行失败；
        </p>
      </div>
      <div v-if="types == 10" class="weekmargin">
        <el-checkbox-group v-model="week">
          <el-checkbox v-for="city in cities" :label="city.lable" :key="city.lable">{{ city.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div v-if="types == 10" class="timecenter">
        <el-time-select v-model="time" size="mini" :picker-options="{
          start: '00:00',
          step: '00:15',
          end: '23:30'
        }" :placeholder="$t('lang.Dialog.translators')"></el-time-select>
      </div>
      <div style="text-align:center;">
        <p v-if="types == 7 || types == 8">
          <span class="tetxp">{{ $t('lang.Dialog.interface') }}：</span>
          <el-input v-model="serial" size="mini" style="width:5rem;" placeholder="输入接口序号"></el-input>
        </p>
      </div>
      <slot></slot>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showDialog">{{ $t('lang.Dialog.cancel') }}</el-button>
        <el-button size="mini" type="primary" @click="confirmOperate">{{ $t('lang.Dialog.Determine') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('lang.Dialog.prompt')" :visible.sync="centerDialogVisible" width="30%" center>
      <div style="text-align:center">
        <span>{{ $t('lang.Dialog.Weltordnung') }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downlloadFile">{{ $t('lang.Dialog.download') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  operateDevice,
  findDeviceLog,
  findDeviceConfiguration,
  configurationFileManagerdownload,
  logManagerdownload
} from "@/api/devicelist";
import { progressControl } from "@/api/particulars.js"
export default {
  props: {
    //选中设备名与设备id--设备列表传入
    Devicelistname: {
      default: []
    },
    //设备列表操作选中下拉值
    types: {
      type: String
    },
    //远程操作名
    title: {
      type: String
    },
    //定时重启参数
    TimedRestart: {
      type: Object
    }
  },
  data() {
    return {
      //文件下载弹层控制
      centerDialogVisible: false,
      //文件下载链接
      uphref: "",
      //弹出层显示控制
      Device: false,
      //定时重启时间
      time: "",
      //定时重启日期0为周日
      week: [],
      //日期选择
      cities: [
        { name: this.$t('lang.Dialog.Monday'), lable: "1" },
        { name: this.$t('lang.Dialog.Tuesday'), lable: "2" },
        { name: this.$t('lang.Dialog.Wednesday'), lable: "3" },
        { name: this.$t('lang.Dialog.Thursday'), lable: "4" },
        { name: this.$t('lang.Dialog.Friday'), lable: "5" },
        { name: this.$t('lang.Dialog.saturday'), lable: "6" },
        { name: this.$t('lang.Dialog.sunday'), lable: "0" }
      ],
      //接口序号
      serial: "",
      //定时器
      timefind: null,
      url: location.origin,
      dname: "",
      m2mList: [],
      m2mTimer: null,
      m2mIndex: 0,
      m2mFinish: 0,
    };
  },
  methods: {
    //弹出层显示隐藏
    showDialog() {
      this.Device = !this.Device;
    },
    downlloadFile() {
      fetch(this.uphref).then(res => res.blob().then(blob => {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(blob);
        var filename = '';
        this.Devicelistname.forEach((val, index, Arr) => {
          filename += val.deviceSn;
        });
        a.href = url;
        // 判断this.dname后缀是否为txt,是的话就用filename + '.txt',不是的话就用this.dname
        if (this.dname.indexOf(".txt") != -1) {
          a.download = filename + '.txt';
        } else {
          a.download = this.dname;
        }
        a.click();
        window.URL.revokeObjectURL(url);
      }));
    },
    dialogClose() {
      this.m2mList = [];
      if (this.m2mTimer) {
        clearInterval(this.m2mTimer);
        this.m2mTimer = null;
        this.m2mIndex = 0;
        this.m2mFinish = 0;
      }
    },
    //上传操作
    async confirmOperate() {
      if (this.title == this.$t('lang.devicelist.reloadM2M')) {
        this.m2mList = Array.from(this.Devicelistname).map(i => {
          return {
            ...i,
            status: 'info'
          }
        });
        if (this.m2mFinish != 0) {
          return this.$message({
            showClose: true,
            message: this.$t('lang.Dialog.executing'),
            type: "warning",
          })
        } else if (this.m2mFinish == 0) {
          this.m2mFinish = this.m2mList.length;
        }
        this.m2mTimer = null;
        this.m2mTimer = setInterval(() => {
          if (this.m2mIndex == this.m2mList.length) {
            clearInterval(this.m2mTimer);
            this.m2mTimer = null;
            this.m2mIndex = 0;
            return
          }
          let item = this.m2mList[this.m2mIndex]
          try {
            progressControl([{ process: 'smartm2m', action: 'restart', type: 0 }], item.deviceId, item.deviceSn).then((resp) => {
              console.log(item);
              if (resp.data.code === 0) {
                item.status = 'success';
              } else {
                item.status = 'danger';
              }
            }).catch(() => {
              item.status = 'danger';
            }).finally(() => {
              this.m2mFinish--;
              if (this.m2mFinish == 0) {
                this.$message.success("执行完成!");
              }
            })
          } catch {
            this.m2mFinish--;
            item.status = 'danger';
          }
          this.m2mIndex++;
        }, 1000);
        return;
      }
      //获取当前选中设备did
      let arr = [];
      //Devicelistname为选中的设备列表父组件传过来，Set集合，需要循环出来
      this.Devicelistname.forEach((val, index, Arr) => {
        arr.push(val.deviceDid.toString());
      });
      let StringArr = "";
      //后端要我给他排序之后再传过去
      if (this.week.length >= 2) {
        this.week.sort((x, y) => {
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
      }
      if (this.week.length > 0) {
        this.week.forEach((val, index, arr) => {
          StringArr += val;
        });
      }
      //这里获取获取设备日志改了一下，调用另外的接口
      if (this.title == this.$t('lang.Dialog.personsto')) {
        //获取set集合里面的did
        //调用operateDevice接口让设备日志上传到服务器
        //operateDevice接口did参数为数组findDeviceLog接口did参数为字符串两个参数上传不同需要区分
        operateDevice(arr, this.types, this.time, StringArr, this.serial).then(
          res => {
            //如果operateDevice返回成功调用findDeviceLog接口10秒未返回data为失败
            if (res.data.code == 0) {
              let did = null;
              this.Devicelistname.forEach((val, index, arr) => {
                did = val.deviceDid;
              });
              //隐藏弹出框
              this.showDialog();
              let i = 1;
              //10秒内未返回文件为失败
              this.timefind = setInterval(() => {
                if (i < 10) {
                  findDeviceLog(did).then(res => {
                    if (res.data.data) {
                      window.clearInterval(this.timefind);
                      this.$message({
                        showClose: true,
                        message: this.$t('lang.Dialog.SkinVector'),
                        type: "success"
                      });
                      this.uphref = `${this.url}/api/logManager/download?downloadUrl=${res.data.data.downloadUrl
                        }&realFileName=${res.data.data.realFileName}`;
                      this.dname = res.data.data.realFileName;
                      this.centerDialogVisible = true;
                    } else if (!res.data.data) {
                      this.$message({
                        showClose: true,
                        message: this.$t('lang.Dialog.allocator'),
                        type: "warning",
                        duration: 1000
                      });
                      i++;
                    }
                  });
                } else {
                  window.clearInterval(this.timefind);
                  this.$message({
                    showClose: true,
                    message: this.$t('lang.Dialog.WaitForMultipleObjects'),
                    type: "error",
                    duration: 1000
                  });
                }
              }, 1200);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('lang.Dialog.WaitForMultipleObjects'),
                type: "error"
              });
            }
          }
        );
      }
      //这里获取获取备份配置文件改了一下，调用另外的接口
      else if (this.title == this.$t('lang.Dialog.Backup')) {
        //获取set集合里面的did
        //调用operateDevice接口让设备将配置上传到服务器
        //operateDevice接口did参数为数组findDeviceLog接口did参数为字符串两个参数上传不同需要区分
        operateDevice(arr, this.types, this.time, StringArr, this.serial).then(
          res => {
            //如果operateDevice返回成功调用findDeviceLog接口10秒未返回data为失败
            if (res.data.code === 0) {
              let did = null;
              this.Devicelistname.forEach((val, index, arr) => {
                did = val.deviceDid;
              });
              //隐藏弹出框
              this.showDialog();
              let i = 1;
              //10秒内未返回文件为失败
              this.timefind = setInterval(() => {
                if (i < 10) {
                  findDeviceConfiguration(did).then(res => {
                    if (res.data.data) {
                      window.clearInterval(this.timefind);
                      this.$message({
                        showClose: true,
                        message: this.$t('lang.Dialog.SkinVector'),
                        type: "success"
                      });
                      this.uphref = `${this.url}/api/configurationFileManager/download?downloadUrl=${res.data.data.downloadUrl
                        }&realFileName=${res.data.data.realFileName}`;
                      this.dname = res.data.data.realFileName;
                      this.centerDialogVisible = true;
                    } else if (!res.data.data) {
                      this.$message({
                        showClose: true,
                        message: this.$t('lang.Dialog.allocator'),
                        type: "warning",
                        duration: 1000
                      });
                      i++;
                    }
                  });
                } else {
                  window.clearInterval(this.timefind);
                  this.$message({
                    showClose: true,
                    message: this.$t('lang.Dialog.WaitForMultipleObjects'),
                    type: "error",
                    duration: 1000
                  });
                }
              }, 1200);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('lang.Dialog.WaitForMultipleObjects'),
                type: "error"
              });
            }
          }
        );
      } else {
        if ((StringArr == '' || this.time == '') && (this.title === this.$t('lang.devicelist.Timer'))) return this.$message({
          type: "warning",
          message: "请选择正确的时间"
        })
        operateDevice(arr, this.types, this.time, StringArr, this.serial).then(
          res => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t('lang.Dialog.operation'),
                type: "success"
              });
              this.Device = false;
              this.serial = "";
            } else {
              this.$message({
                showClose: true,
                message: this.$t('lang.Dialog.BoxapiJSONOperation'),
                type: "warning"
              });
              this.Device = false;
              this.serial = "";
            }
          }
        );
      }
    }
  },
  beforeDestroy() {
    if (this.Device)
      this.$emit('close');
    this.m2mList = [];
    window.clearInterval(this.timefind);
  },
  watch: {
    Device: {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.time = ""
          this.week = []
          this.$emit('RemType')
        }
      }
    },
    TimedRestart: {
      handler(newValue, oldValue) {
        if (Object.keys(newValue).length > 0) {
          this.time = newValue.hour + ':' + newValue.min
          this.week = newValue.period.split(' ')
        }
      }
    }
  }
};
</script>
<style scoped>
.Device-list-name {
  font-size: 0.3rem;
  font-weight: 500;
  text-align: center;
}

li {
  display: inline-block;
  margin: 0.2rem;
}

.timecenter {
  text-align: center;
}

.weekmargin {
  margin: 0.3rem 0rem;
}

.tetxp {
  display: inline-block;
  width: 1.5rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}

.status {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.status>div {
  border: 1px solid #aaa;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
